// extracted by mini-css-extract-plugin
export var sliderRange = "_qk-2";
export var sliderRoot = "_qk-0";
export var sliderThumb = "_qk-3";
export var sliderTrack = "_qk-1";